import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import * as React from 'react';
export default {
  Label,
  PropTableValues,
  React
};